/* Calma Produktseite: Streichpreis, Gutschein, Bewertungs-Slider, Lieferzeit, Video-Reihe.
   Preis, Abo und Kaufleiste bleiben in calma.js; hier nur die Ergaenzungen. */
(function(){
  "use strict";
  if (window.__calmaPdp) return; window.__calmaPdp = true;   /* nur einmal initialisieren */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function eur(v){ return v.toFixed(2).replace(".", ",") + " €"; }
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Streichpreis + Ersparnis oben neben dem Preis ---------- */
  function strike(){
    var sel = $('input[data-menge]:checked') || $('input[data-menge]');
    var was = $("#total-was"), tag = $("#total-save");
    if (!sel || !was) return;
    var abo = !!$('input[name="modus"][value="abo"]:checked');
    var p = parseFloat(abo && sel.dataset.priceAbo ? sel.dataset.priceAbo : sel.dataset.price);
    var w = parseFloat(sel.dataset.was);
    if (abo && !isFinite(w)) w = parseFloat(sel.dataset.price);   /* im Abo: Einmalpreis als Vergleich */
    var on = isFinite(w) && isFinite(p) && w > p + 0.004;
    was.hidden = !on;
    if (tag) tag.hidden = !on;
    if (!on) return;
    was.textContent = eur(w);
    if (tag) tag.textContent = "−" + Math.round((1 - p / w) * 100) + " %";
    var alt = $("#total-alt"); if (alt) alt.hidden = true;  /* doppelter Streichpreis aus calma.js */
  }
  document.addEventListener("change", function(e){
    var t = e.target;
    if (t && (t.hasAttribute("data-menge") || t.name === "modus")) setTimeout(strike, 0);
  });
  strike();

  /* ---------- Gutscheincode kopieren ---------- */
  $$("[data-copy]").forEach(function(b){
    b.addEventListener("click", function(){
      var code = b.dataset.copy, label = b.querySelector("span"), old = label.textContent;
      var done = function(){ label.textContent = "Kopiert"; b.classList.add("is-done");
        setTimeout(function(){ label.textContent = old; b.classList.remove("is-done"); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  });

  /* ---------- Bewertungs-Slider ---------- */
  $$("[data-qslider]").forEach(function(box){
    var track = $(".qs-track", box), cards = $$(".qs-card", box), i = 0, timer;
    if (cards.length < 2){ $$(".qs-nav", box).forEach(function(n){ n.hidden = true; }); return; }
    function go(n){
      i = (n + cards.length) % cards.length;
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: reduce ? "auto" : "smooth" });
    }
    $$(".qs-nav", box).forEach(function(n){
      n.addEventListener("click", function(){ go(i + parseInt(n.dataset.qs, 10)); restart(); });
    });
    track.addEventListener("scroll", function(){
      var x = track.scrollLeft, best = 0, d = Infinity;
      cards.forEach(function(c, k){ var dd = Math.abs(c.offsetLeft - track.offsetLeft - x); if (dd < d){ d = dd; best = k; } });
      i = best;
    }, { passive: true });
    function restart(){ clearInterval(timer); if (!reduce) timer = setInterval(function(){ go(i + 1); }, 6500); }
    box.addEventListener("pointerenter", function(){ clearInterval(timer); });
    box.addEventListener("pointerleave", restart);
    restart();
  });

  /* ---------- Lieferzeit: Bestellschluss, Versandtag, Zustellfenster (Zeit in Deutschland) ---------- */
  $$("[data-eta]").forEach(function(box){
    var cutoff = parseInt(box.dataset.cutoff, 10) || 13,
        handling = parseInt(box.dataset.handling, 10) || 0,
        tmin = parseInt(box.dataset.min, 10) || 1,
        tmax = parseInt(box.dataset.max, 10) || 3;
    var TAGE = ["So","Mo","Di","Mi","Do","Fr","Sa"];

    function berlinNow(){
      var p = {};
      new Intl.DateTimeFormat("en-GB", { timeZone:"Europe/Berlin", year:"numeric", month:"2-digit", day:"2-digit",
        hour:"2-digit", minute:"2-digit", hour12:false }).formatToParts(new Date())
        .forEach(function(x){ p[x.type] = x.value; });
      return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour % 24, m: +p.minute };
    }
    function workday(d){ var w = d.getUTCDay(); return w !== 0 && w !== 6; }
    function addWork(d, n){ var x = new Date(d); while (n > 0){ x.setUTCDate(x.getUTCDate() + 1); if (workday(x)) n--; } return x; }
    function fmt(d){ return TAGE[d.getUTCDay()] + ", " + String(d.getUTCDate()).padStart(2,"0") + "." + String(d.getUTCMonth()+1).padStart(2,"0") + "."; }

    function render(){
      var now = berlinNow(), today = now.d, beforeCut = workday(today) && now.h < cutoff;
      var ship = beforeCut ? today : addWork(today, 1);
      if (handling > 0) ship = addWork(ship, handling);
      var a = addWork(ship, tmin), b = addWork(ship, tmax);
      var same = ship.getTime() === today.getTime();
      $("[data-eta-b]", box).textContent = same ? "Heute" : fmt(ship);
      $("[data-eta-c]", box).textContent = fmt(a) + " – " + fmt(b);
      var line = $("[data-eta-line]", box);
      if (beforeCut && handling === 0){
        var mins = (cutoff * 60) - (now.h * 60 + now.m), hh = Math.floor(mins / 60), mm = mins % 60;
        line.innerHTML = "Bestellst du in den nächsten <b>" + (hh ? hh + " Std. " : "") + mm + " Min.</b>, ist dein Paket zwischen <b>" + fmt(a) + "</b> und <b>" + fmt(b) + "</b> bei dir.";
      } else {
        line.innerHTML = "Bestellst du jetzt, ist dein Paket zwischen <b>" + fmt(a) + "</b> und <b>" + fmt(b) + "</b> bei dir.";
      }
    }
    render();
    setInterval(render, 30000);
  });

  /* ---------- Video-Reihe: laeuft stumm, sobald sie im Bild ist; Antippen pausiert/spielt.
     Der Play-Button ist nur sichtbar, solange das Video pausiert. ---------- */
  var ugc = $$(".ugc-item");
  /* Videos erst laden, wenn sie in die Naehe des Viewports kommen */
  function load(v){ if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src; }
  if (ugc.length && "IntersectionObserver" in window){
    var lo = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ load($("video", en.target)); lo.unobserve(en.target); } });
    }, { rootMargin: "300px 0px" });
    ugc.forEach(function(fig){ lo.observe(fig); });
  } else ugc.forEach(function(fig){ load($("video", fig)); });
  ugc.forEach(function(fig){
    var v = $("video", fig), btn = $(".ugc-play", fig);
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", "");
    function sync(){
      var on = !v.paused && !v.ended;
      fig.classList.toggle("is-playing", on);
      btn.setAttribute("aria-label", on ? "Video pausieren" : "Video abspielen");
    }
    function play(){ load(v); var pr = v.play(); if (pr && pr.catch) pr.catch(sync); }
    v.addEventListener("play", sync);
    v.addEventListener("playing", sync);
    v.addEventListener("pause", sync);
    function toggle(e){
      if (e) e.preventDefault();
      fig._userPaused = !v.paused;
      if (v.paused) play(); else v.pause();
    }
    btn.addEventListener("click", toggle);
    v.addEventListener("click", toggle);
    sync();
  });
  if (ugc.length && !reduce && "IntersectionObserver" in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var fig = en.target, v = $("video", fig);
        if (en.isIntersecting && en.intersectionRatio > 0.5){ if (v.paused && !fig._userPaused){ load(v); var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); } }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.5, 1] });
    ugc.forEach(function(fig){ io.observe(fig); });
  }
})();
